import {
  clearOnLogout,
  getAuthTokenFromLocalStorage,
  refreshToken,
} from '@features/auth';
import axios, {isAxiosError} from 'axios';

const createAuthInterceptors = (instance: ReturnType<typeof axios.create>) => {
  instance.interceptors.request.use(function (config) {
    const token = getAuthTokenFromLocalStorage();
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    return config;
  });

  instance.interceptors.response.use(
    response => response,
    async (error: unknown) => {
      if (!isAxiosError(error)) {
        throw error;
      }

      const resp = error.response;
      const token = getAuthTokenFromLocalStorage();

      if (resp?.status === 401 && !token) {
        // TODO shared uses code from feature. That conflicts with FSD.
        clearOnLogout();
        window.location.reload();
      }

      const config = error?.config;

      // Add "sent" flag
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (error?.response?.status === 401 && config && !config.sent) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        config.sent = true;

        let newAuthToken;
        try {
          // TODO shared uses code from feature. That conflicts with FSD.
          newAuthToken = await refreshToken();
        } catch (e) {
          clearOnLogout();
          window.location.reload();
        }

        if (newAuthToken) {
          config.headers.Authorization = `Bearer ${newAuthToken}`;
          return axios(config);
        }
      }

      throw error;
    },
  );
};

export const axi = axios.create({
  // For development the proxying is used
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? ''
      : import.meta.env.VITE_API_URL) + '/v1',
});

createAuthInterceptors(axi);

export const axiTasks = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/tasks'
      : import.meta.env.VITE_TASKS_API_URL) + '/v1',
});

createAuthInterceptors(axiTasks);

export const axiTasksV2 = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/tasks'
      : import.meta.env.VITE_TASKS_API_URL) + '/v2',
});

createAuthInterceptors(axiTasksV2);

export const axiPayment = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/payment'
      : import.meta.env.VITE_PAYMENT_API_URL) + '/v1',
});

createAuthInterceptors(axiPayment);

export const axiOrders = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/orders'
      : import.meta.env.VITE_ORDERS_API_URL) + '/v1',
});

createAuthInterceptors(axiOrders);

export const axiParimutuel = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/parimutuel'
      : import.meta.env.VITE_PARIMUTUEL_API_URL) + '/v1',
});

createAuthInterceptors(axiParimutuel);

export const axiFootball = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/football'
      : import.meta.env.VITE_FOOTBALL_API_URL) + '/v1',
});

createAuthInterceptors(axiFootball);

export const axiBasketball = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/basketball'
      : import.meta.env.VITE_BASKETBALL_API_URL) + '/v1',
});

createAuthInterceptors(axiBasketball);

export const axiVolleyball = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/volleyball'
      : import.meta.env.VITE_VOLLEYBALL_API_URL) + '/v1',
});

createAuthInterceptors(axiVolleyball);

export const axiMma = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/mma'
      : import.meta.env.VITE_MMA_API_URL) + '/v1',
});

createAuthInterceptors(axiMma);

export const axiBoxing = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/boxing'
      : import.meta.env.VITE_BOXING_API_URL) + '/v1',
});

createAuthInterceptors(axiBoxing);

export const axiDota2 = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/dota2'
      : import.meta.env.VITE_DOTA2_API_URL) + '/v1',
});

createAuthInterceptors(axiDota2);

export const axiYoutube = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/youtube'
      : import.meta.env.VITE_YOUTUBE_API_URL) + '/v1',
});

createAuthInterceptors(axiYoutube);

export const axiCrypto = axios.create({
  baseURL:
    (import.meta.env.VITE_ENABLED_API_PROXYING === 'true'
      ? '/crypto'
      : import.meta.env.VITE_CRYPTO_API_URL) + '/v1',
});

createAuthInterceptors(axiCrypto);
